/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";
const EMP_URL      = `${API_BASE_URL}/api/employees`;
const ADMIN_PASS   = "admin123"; // matches const ADMIN_PASS in sendo tracker

export default function EmployeePasswords() {
  const [employees, setEmployees]       = useState([]);
  const [passwords, setPasswords]       = useState({}); // name -> password
  const [commonPass, setCommonPass]     = useState("sendo123");
  const [commonInput, setCommonInput]   = useState("");
  const [commonSaved, setCommonSaved]   = useState(false);
  const [newEmpName, setNewEmpName]     = useState("");
  const [newEmpPass, setNewEmpPass]     = useState("");
  const [search, setSearch]             = useState("");
  const [savingId, setSavingId]         = useState(null);
  const [loading, setLoading]           = useState(false);

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const res = await axios.get(EMP_URL);
      const data = res.data?.data || res.data || [];
      setEmployees(data);
      // Build password map from DB data
      const pwMap = {};
      data.forEach(e => { if (e.password) pwMap[e.name] = e.password; });
      setPasswords(pwMap);
    } catch (e) {
      console.error(e);
      alert("Error: " + (e?.response?.data?.message || e.message || "Operation failed."));
    }
    setLoading(false);
  };

  useEffect(() => { fetchEmployees(); }, []);

  const handleSavePassword = async (name) => {
    setSavingId(name);
    try {
      await axios.put(`${EMP_URL}/${encodeURIComponent(name)}`, { password: passwords[name] || "" });
    } catch (e) { alert("Save failed"); }
    setSavingId(null);
  };

  const handleDeleteEmployee = async (name) => {
    if (!window.confirm(`Remove employee "${name}"?`)) return;
    try {
      await axios.delete(`${EMP_URL}/${encodeURIComponent(name)}`);
      fetchEmployees();
    } catch (e) { alert("Delete failed"); }
  };

  const handleAddEmployee = async () => {
    const n = newEmpName.trim().toUpperCase();
    if (!n) return;
    try {
      await axios.post(EMP_URL, { name: n, password: newEmpPass.trim() });
      setNewEmpName(""); setNewEmpPass("");
      fetchEmployees();
    } catch (e) { alert("Add failed"); }
  };

  const handleSetCommonPass = () => {
    if (!commonInput.trim()) { alert("Enter a password"); return; }
    setCommonPass(commonInput.trim());
    setCommonInput("");
    setCommonSaved(true);
    setTimeout(() => setCommonSaved(false), 3000);
    // In production, persist this to backend config
  };

  const filteredEmployees = employees.filter(e =>
    (e.name || "").toLowerCase().includes(search.toLowerCase())
  );

  const S = {
    container:  { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    body:       { padding: "20px" },
    card:       { background: "#fff", border: "1px solid #000", borderRadius: 8, padding: "16px 18px", marginBottom: 16 },
    cardTitle:  { fontWeight: "bold", fontSize: 14, marginBottom: 10 },
    infoBox:    { background: "#fff8e1", border: "1px solid #f59e0b", borderRadius: 6, padding: "10px 14px", fontSize: 13, marginBottom: 8 },
    infoBoxBlue:{ background: "#e3f2fd", border: "1px solid #1565c0", borderRadius: 6, padding: "10px 14px", fontSize: 13, marginBottom: 8 },
    row:        { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
    input:      { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    btnYellow:  { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:   { background: "#000", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnRed:     { background: "transparent", border: "1px solid #c0392b", color: "#c0392b", padding: "4px 10px", borderRadius: 5, cursor: "pointer", fontSize: 12 },
    empCard:    { background: "#fafafa", border: "1px solid #ddd", borderRadius: 8, overflow: "hidden", marginBottom: 8 },
    empHead:    { display: "flex", alignItems: "center", gap: 10, padding: "10px 14px" },
    empFoot:    { display: "flex", gap: 8, padding: "0 14px 10px 58px" },
    code:       { background: "#f5f5f5", border: "1px solid #ddd", borderRadius: 4, padding: "2px 8px", fontFamily: "monospace", fontSize: 13 },
    success:    { color: "#27ae60", fontWeight: "bold", fontSize: 13 },
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Employee Passwords</h2>
      <div style={S.body}>

        {/* Info: Admin Password */}
        <div style={S.card}>
          <div style={S.infoBox}>
            💡 <strong>Admin password</strong> can be changed by editing <code style={S.code}>const ADMIN_PASS</code> in the source file.&nbsp;
            Current admin password: <code style={S.code}>{ADMIN_PASS}</code>
          </div>
          <div style={S.infoBoxBlue}>
            🔑 Common employee password: <code style={S.code}>{commonPass}</code>
            <div style={{ marginTop: 6, fontSize: 12, color: "#555" }}>
              Employees select their vehicle/name and enter this password to log in. Individual passwords override this.
            </div>
          </div>

          {/* Change common password */}
          <div style={S.cardTitle}>Change Common Employee Password</div>
          <div style={S.row}>
            <input
              style={S.input}
              placeholder="New common password..."
              value={commonInput}
              onChange={e => setCommonInput(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSetCommonPass()}
            />
            <button style={S.btnYellow} onClick={handleSetCommonPass}>✅ Set Password</button>
            {commonSaved && <span style={S.success}>✅ Common password updated to: <strong>{commonPass}</strong></span>}
          </div>
        </div>

        {/* Quick add — full form: Employee onboarding page */}
        <div style={S.card}>
          <div style={S.cardTitle}>➕ Quick add (name &amp; password)</div>
          <div style={S.row}>
            <input
              style={{ ...S.input, minWidth: 160 }}
              placeholder="Employee name..."
              value={newEmpName}
              onChange={e => setNewEmpName(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleAddEmployee()}
            />
            <input
              style={{ ...S.input, width: 140 }}
              placeholder="Password..."
              value={newEmpPass}
              onChange={e => setNewEmpPass(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleAddEmployee()}
            />
            <button style={S.btnYellow} onClick={handleAddEmployee}>➕ Add</button>
          </div>
        </div>

        {/* Employee List with passwords */}
        <div style={S.card}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <div style={S.cardTitle}>👤 Employees
              <span style={{ marginLeft: 10, background: "#e3f2fd", color: "#1565c0", borderRadius: 20, padding: "2px 10px", fontSize: 12, fontWeight: "bold" }}>
                {employees.length}
              </span>
            </div>
            <input style={S.input} placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>

          {loading ? (
            <p style={{ color: "#888", fontSize: 13 }}>Loading employees...</p>
          ) : filteredEmployees.length === 0 ? (
            <p style={{ color: "#888", fontSize: 13 }}>No employees found. Use Employee onboarding above.</p>
          ) : filteredEmployees.map((emp, i) => {
            const hasPw = !!(passwords[emp.name] || emp.password);
            return (
              <div key={emp._id || emp.name} style={S.empCard}>
                <div style={S.empHead}>
                  {/* Avatar */}
                  <div style={{
                    width: 32, height: 32, borderRadius: "50%",
                    background: "rgba(56,189,248,0.1)", border: "1px solid rgba(56,189,248,0.3)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 12, fontWeight: "bold", color: "#1565c0", flexShrink: 0,
                  }}>
                    {i + 1}
                  </div>
                  {/* Name */}
                  <div style={{ flex: 1, fontWeight: "bold", fontSize: 13 }}>{emp.name}</div>
                  {/* Status badge */}
                  <span style={{
                    fontSize: 11, padding: "2px 10px", borderRadius: 20, fontWeight: "bold",
                    background: hasPw ? "#e6f9ee" : "#fff8e1",
                    color: hasPw ? "#27ae60" : "#d68910",
                    border: hasPw ? "1px solid #27ae60" : "1px solid #f59e0b",
                  }}>
                    {hasPw ? "🔒 Password Set" : "⚠️ No Password"}
                  </span>
                  {/* Delete */}
                  <button style={S.btnRed} onClick={() => handleDeleteEmployee(emp.name)}>✕</button>
                </div>
                <div style={S.empFoot}>
                  <input
                    style={{ ...S.input, flex: 1 }}
                    placeholder="Set password..."
                    value={passwords[emp.name] || ""}
                    onChange={e => setPasswords({ ...passwords, [emp.name]: e.target.value })}
                    onKeyDown={e => e.key === "Enter" && handleSavePassword(emp.name)}
                  />
                  <button
                    style={{ ...S.btnYellow, padding: "6px 14px", fontSize: 12 }}
                    onClick={() => handleSavePassword(emp.name)}
                    disabled={savingId === emp.name}
                  >
                    {savingId === emp.name ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
